export default '$$joy';
